module.exports = __webpack_public_path__ + "static/img/icon-3.3313e10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/icon-3.png
// module id = KO1z
// module chunks = 0